import localforage from 'localforage';
import { useCommonInfoStore } from '@shared/store/common';
import { FULL_STEP_AGGREGATION_REPLACE_MAP } from '@shared/constants/analysis';

export const temporaryDashboardDb = localforage.createInstance({
  name: 'conviva_user_journey',
  storeName: 'analysis_dashboards_temporary',
});

export function generateDefaultTemporaryDashboard(
  params: Partial<
    Pick<
      FunnelAnalyses,
      | 'critical_events'
      | 'filters'
      | 'time_range'
      | 'timeout'
      | 'propagation_config'
      | 'dimension_analyses'
    >
  >,
): Omit<FunnelAnalyses, 'name'> {
  const { defaultInterval } = useCommonInfoStore.getState();

  return {
    critical_events: params.critical_events ?? [],
    timeout: params.timeout ?? {
      val: 1,
      unit: 'h',
    },
    propagation_config: params.propagation_config ?? {},
    filters: params.filters,
    time_range: params.time_range ?? defaultInterval,
    dimension_analyses: params.dimension_analyses ?? [
      {
        dimension: 'app_name',
        aggregations: ['unique_user_id', 'user_conversion_rate'],
        order_by: getDefaultOrderBy(['unique_user_id', 'user_conversion_rate']),
      },
    ],
  };
}

export const getDefaultOrderBy = (currentMetrics: string[]) => ({
  step: 'full' as const,
  field: FULL_STEP_AGGREGATION_REPLACE_MAP[currentMetrics[0]] ?? currentMetrics[0],
  order: 'desc' as const,
});
